const INSTRUCTORS = {
  abraham: {
    slug: 'abraham',
    firstName: 'Abraham',
    lastName: 'Najjarine',
    photoUrl: '/instructor-photos/abraham.jpg',
    yearsExperience: 8,
  }
};

export const DEMO_CLASS_SESSIONS = [
  {
    id: 'class-001',
    courseSlug: 'math-bootcamp',
    subject: 'Math Bootcamp',
    format: 'Group Bootcamp',
    pricing: { amount: 25, unit: 'hour', perStudent: true },
    instructor: INSTRUCTORS.abraham,
    meetings: [
      { day: 'Monday', start: '14:00', end: '16:00' },
      { day: 'Wednesday', start: '14:00', end: '16:00' },
    ],
    timezone: 'CT',
    location: 'Plano, TX',
    startDate: '2026-06-01',
    durationWeeks: 11,
    enrollDeadline: '2026-05-24',
    maxSeats: 4,
    enrolledStudents: ['Sarah K.', 'Michael R.'],
    rating: 4.9,
    ratingCount: 23,
    graduationRate: 92,
    graduatedCount: 47,
  }
];